import React from 'react';

import { HotelContactInfo } from './contact';
import { HotelAmenities } from './amenities';
import { HotelImageGallery } from '../HotelImageGallery';
import { HotelRating } from './rating';
import { HotelOverview } from './overview';
import { HotelLocation } from './location';
import { Offers } from './offers';


export const HotelInfo = ({
    data, geoCodes, photoRef, amenitiesRef,
    locationRef, reviewRef, overviewRef, offersRef
}) => {

    return (
        <React.Fragment>
            <HotelOverview data={data} overviewRef={overviewRef} />
            <HotelAmenities data={data} amenitiesRef={amenitiesRef} />
            {
                Array.isArray(data.images) && data.images.length ?
                    <HotelImageGallery data={data} photoRef={photoRef} />
                    :
                    null
            }
            {
                (data.rating?.google || data.rating?.global || data.rating?.tripadvisor) ?
                    <HotelRating data={data} reviewRef={reviewRef} />
                    :
                    null
            }
            <HotelLocation geoCodes={geoCodes} locationRef={locationRef} />
            <Offers data={data} offersRef={offersRef} />
            <HotelContactInfo data={data} />
        </React.Fragment>
    )
}
